export const meta: BlockMeta = {
  title: "Person",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/person", (props) => {
  return (
    <div className={cn("grid-auto my-5")}>
      <div className={cn("col-span-12", "md:col-span-8 md:col-start-3")}>
        <div className="w-full bg-grey8 p-4 flex flex-col justify-between items-center gap-4">
          <div className="w-full flex gap-4 items-center">
            <div className="w-10 h-10 overflow-hidden shrink-0">
              <ResponsiveImage {...props.image} objectFit="cover" className="w-full h-full" />
            </div>
            <div className="w-full flex flex-col gap-2">
              <EditableText
                as="p"
                className="type-title-xs"
                store="title"
                defaultValue="Example Name"
                placeholder="Example Name"
                plainText
              />
              <EditableText
                as="p"
                className="type-label-xs"
                store="subtitle"
                defaultValue="Example Role"
                placeholder="Example Role"
                plainText
              />
            </div>
          </div>

          <div className="w-full flex flex-col gap-4 [&_.wp-block]:my-0 [&_.block-image]:my-0 [&_.block-image]:-ml-6 [&_.image-caption]:!hidden [&_.block-image]:w-[calc(100%+(var(--spacing-6)*2))] md:[&_.block-image]:-ml-5 md:[&_.block-image]:w-[calc(100%+(var(--spacing-5)*2))] [&_button]:my-0 [&_p]:my-0 [&_.core-rich-text]:flex [&_.core-rich-text]:flex-col [&_.core-rich-text]:gap-4 [&_.wp-block-heading]:my-0 [&_button]:!w-full [&_button]:!justify-start [&_p]:type-body-m">
            <InnerBlocks
              allowedBlocks={["richtext"]}
              orientation="horizontal"
              adminClassName="w-full flex flex-col gap-4"
              template={[["core/paragraph", { placeholder: "Example text" }]]}
            />
          </div>
        </div>
      </div>
    </div>
  )
})
